<template>
	<div>
		<div class="q_center" style="margin-top: 26vh;">
			<!-- 失败图标 -->
			<!-- <img src="../../assets/image/bad.png" style="width: 26vw;" /> -->
			<!-- 成功图标 -->
			<img src="@/assets/image/success.png" style="width: 26vw;" />
			<p class="q_color_gray q_text_s q_mar_t20px">申请成功</p>
			<!-- 成功兑换时同时显示两个按钮 -->
			<!-- <van-button round type="primary" color="#FF5733" class="q_mar_t20px q_mar_r20px" @click="goToExchangedea()">查看兑换</van-button> -->
			<van-button plain round type="primary" color="#FF5733" class="q_mar_t20px" @click="goToHome()">返回首页</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Feedback',
		props: {
			msg: String
		},
		data() {
			return {
				show: false,
			}
		},
		methods: {
			goToHome() {
				this.$router.push({
					path: '/'
				});
			},
			goToExchangedea() {
				this.$router.push({
					path: '/mine/Exchangedea'
				});
			},
		},
	}
</script>
<style scoped="scoped">
	.van-button{
		height: 36px;
	}
</style>
